import axios from "axios";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest } from "components/Types/GeneralTypes";
import config from "config.json";
import { authHeader, authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { HistorialPermisosSolicitudes } from "../Solicitud Permisos/TypesSolicitudesPermisos";

export async function ObtenerAniosHistorialPermisos(){
    const URL = config.SERVER_URL + "SolicitudPermisos/HistorialPermisos/AniosDisponibles"
    const datosUsuario: UserData = authenticationService.currentUserValue;
    var resultado: ResponseRequest = { status: -1 }
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithUserData(datosUsuario)
            })
        const datos: number[] = respuesta.data;
        resultado = { status: respuesta.status, dataResponse: datos }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }

    }
    return resultado;
}

export async function ObtenerAniosHistorialLicencias(){
    const URL = config.SERVER_URL + "SolicitudPermisos/HistorialLicencias/AniosDisponibles"
    const datosUsuario: UserData = authenticationService.currentUserValue;
    var resultado: ResponseRequest = { status: -1 }
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithUserData(datosUsuario)
            })
        const datos: number[] = respuesta.data;
        resultado = { status: respuesta.status, dataResponse: datos }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }

    }
    return resultado;
}

export async function ObtenerHistorialPermisos(anio:number){
    const URL = config.SERVER_URL + "SolicitudPermisos/HistorialPermisos/"+ anio
    const datosUsuario: UserData = authenticationService.currentUserValue;
    var resultado: ResponseRequest = { status: -1 }
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithUserData(datosUsuario)
            })
        const datos: HistorialPermisosSolicitudes[] = respuesta.data;
        resultado = { status: respuesta.status, dataResponse: datos }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }

    }
    return resultado;
}

export async function ObtenerHistorialLicencias(anio:number){
    const URL = config.SERVER_URL + "SolicitudPermisos/HistorialLicencias/"+ anio
    const datosUsuario: UserData = authenticationService.currentUserValue;
    var resultado: ResponseRequest = { status: -1 }
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithUserData(datosUsuario)
            })
        const datos: HistorialPermisosSolicitudes[] = respuesta.data;
        resultado = { status: respuesta.status, dataResponse: datos }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }

    }
    return resultado;
}
